import { render, staticRenderFns } from "./transactionDetail.vue?vue&type=template&id=9187ad56&"
import script from "./transactionDetail.vue?vue&type=script&lang=js&"
export * from "./transactionDetail.vue?vue&type=script&lang=js&"
import style0 from "./transactionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports